import 'ol/ol.css';
import "ol-layerswitcher/dist/ol-layerswitcher.css";
import "ol-ext/dist/ol-ext.css";

import Map from 'ol/Map';
import View from 'ol/View';
import { transform } from 'ol/proj';
import LayerGroup from 'ol/layer/Group';
import TileWMS from 'ol/source/TileWMS';
import TileArcGISRest from 'ol/source/TileArcGISRest';
import ImageWMS from 'ol/source/ImageWMS';
import ImageLayer from 'ol/layer/Image';
import Swipe from 'ol-ext/control/Swipe';
import BingMaps from 'ol/source/BingMaps';
import SourceOSM from 'ol/source/OSM';
import XYZ from 'ol/source/XYZ';
import GeoJSON from 'ol/format/GeoJSON';
import {Fill, Stroke, Style, Text} from 'ol/style';
import VectorSource from 'ol/source/Vector.js';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {getCenter} from 'ol/extent';
import Link from 'ol/interaction/Link';
import Draw from 'ol/interaction/Draw';
import Polygon from 'ol/geom/Polygon';
import {getArea as sphereGetArea, getLength as sphereGetLength} from 'ol/sphere';
import {unByKey} from 'ol/Observable';
import {useGeographic} from 'ol/proj';
import SearchNominatim from 'ol-ext/control/SearchNominatim';
import GeolocationButton from 'ol-ext/control/GeolocationButton';
import Overlay from 'ol/Overlay';

import Projection from 'ol/proj/Projection.js';
import proj4 from 'proj4';
import {toLonLat} from 'ol/proj.js';
import {register} from 'ol/proj/proj4.js';
import TileGrid from 'ol/tilegrid/TileGrid.js';

import LayerSwitcher from 'ol-layerswitcher';

import {Control, defaults as defaultControls} from 'ol/control.js';

import EsriJSON from 'ol/format/EsriJSON.js';
import {tile as tileStrategy} from 'ol/loadingstrategy.js';
import {createXYZ} from 'ol/tilegrid.js';

useGeographic();

// ---- URL parameters ------------------------------------------------------
// ol/interaction/Link owns the x, y, z, r and l search params, so ours must not
// collide with those. Link preserves any other params it finds.
//   ?embed=1            hide every control except zoom +/- (and attribution)
//   ?layers=osm,ha1955  restrict which layers are offered, by slugified title
const urlParams = new URLSearchParams(window.location.search);
const EMBED = ['1', 'true', 'yes'].indexOf((urlParams.get('embed') || '').toLowerCase()) !== -1;

// "HA 1955" -> "ha1955", "USGS Topo 1958" -> "usgstopo1958"
function layerSlug(title) {
  return String(title).toLowerCase().replace(/[^a-z0-9]+/g, '');
}

const serviceUrl =
  'https://gisdata.in.gov/server/rest/services/' +
  'Hosted/Parcel_Boundaries_of_Indiana_Current/FeatureServer/';
const layer = '0';

  const parcelStyle = new Style({
    stroke: new Stroke({
      color: [255, 0, 0, 1],
      width: 0.5,
    }),
  });

// Indiana Projection
proj4.defs("ESRI:102673","+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966666666667 +x_0=100000 +y_0=250000 +datum=NAD83 +units=us-ft +no_defs +type=crs");
register(proj4);

var beaconGrid = new TileGrid({
    maxZoom: 17,
    origin: [-18119800, 20012700],
    resolutions: [660, 550, 440, 385, 330, 275, 220, 165, 110, 55, 27.5, 13.75, 6.875, 4.166666666667, 2.083333333333, 1.041666666667, 0.520833333333, 0.260416666667],
})

var beaconGrid2 = new TileGrid({
    maxZoom: 17,
    origin: [0, 100000000],
    resolutions: [660, 550, 440, 385, 330, 275, 220, 165, 110, 55, 27.5, 13.75, 6.875, 4.166666666667, 2.083333333333, 1.041666666667, 0.520833333333, 0.260416666667],
})

class homeControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.title = "Go Home";
    button.innerHTML = '<img height="100%" src="https://mapstatic.millhousen.com/assets/home.svg">';

    const element = document.createElement('div');
    element.className = 'home-button ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.handleHome.bind(this), false);
    button.addEventListener('dblclick', this.handleSetHome.bind(this), false);
  }

  handleSetHome() {
    const view = map.getView();
    view.setCenter([-85.49914, 39.16392]);
    view.setZoom(17);
    view.setRotation(0);
  }
  handleHome() {
    const view = map.getView();
    view.setCenter([-85.43384, 39.21061]);
    view.setZoom(17);
    view.setRotation(0);

  }
}

class OSMControl extends Control {
    /**
     * @param {Object} [opt_options] Control options.
     */
    constructor(opt_options) {
      const options = opt_options || {};
  
      const button = document.createElement('button');
      button.title = "Open in OpenStreetMap";
      button.innerHTML = '<img height="100%" src="https://mapstatic.millhousen.com/assets/openstreetmap.svg">';
  
      const element = document.createElement('div');
      element.className = 'osm-button ol-unselectable ol-control';
      element.appendChild(button);
  
      super({
        element: element,
        target: options.target,
      });
  
      button.addEventListener('click', this.handleOSM.bind(this), false);
    }
  
    handleOSM() {
        const view = map.getView();
        const center = view.getCenter();
        const zoom = view.getZoom();
      window.open('https://www.openstreetmap.org/#map='+ zoom +'/' + center[1] + '/' + center[0], '_blank').focus();
    }
  }


class MapillaryControl extends Control {
    /**
     * @param {Object} [opt_options] Control options.
     */
    constructor(opt_options) {
      const options = opt_options || {};
  
      const button = document.createElement('button');
      button.title = "Open in Mapillary";
      button.innerHTML = '<img height="100%" src="https://mapstatic.millhousen.com/assets/mapillary.svg">';
  
      const element = document.createElement('div');
      element.className = 'mapillary-button ol-unselectable ol-control';
      element.appendChild(button);
  
      super({
        element: element,
        target: options.target,
      });
  
      button.addEventListener('click', this.handleMapillary.bind(this), false);
    }
  
    handleMapillary() {
        const view = map.getView();
        const center = view.getCenter();
        const zoom = view.getZoom();
      window.open('https://www.mapillary.com/app/?lat=' + center[1] + '&lng=' + center[0] + '&z=' + zoom, '_blank').focus();
    }
  }

  class GMapsControl extends Control {
    /**
     * @param {Object} [opt_options] Control options.
     */
    constructor(opt_options) {
      const options = opt_options || {};
  
      const button = document.createElement('button');
      button.title = "Open in Google Maps";
      button.innerHTML = '<img height="100%" src="https://mapstatic.millhousen.com/assets/googlemaps.svg">';
  
      const element = document.createElement('div');
      element.className = 'gmaps-button ol-unselectable ol-control';
      element.appendChild(button);
  
      super({
        element: element,
        target: options.target,
      });
  
      button.addEventListener('click', this.handleGMaps.bind(this), false);
    }
  
    handleGMaps() {
        const view = map.getView();
        const center = view.getCenter();
        const zoom = view.getZoom();
      window.open('https://www.google.com/maps/@' + center[1] + ',' + center[0] + ',' + zoom + 'z', '_blank').focus();
    }
  }

  // Beacon (Decatur County GIS) parcel lookup.
  // Beacon deep-links by parcel number, not by coordinate, so we resolve the
  // parcel under the map center via Indiana's statewide parcel service and hand
  // its parcel_id to Beacon as KeyValue. AppID 124 is Decatur County, so we only
  // use the parcel link when the center is actually in Decatur (FIPS 18031);
  // otherwise we fall back to Beacon's plain map page.
  const BEACON_APP = 'https://beacon.schneidercorp.com/Application.aspx?AppID=124&LayerID=1376';
  const BEACON_MAP = BEACON_APP + '&PageTypeID=1&PageID=922';
  // Map view centred on the parcel. For the tabular detail/report page instead,
  // swap this for: BEACON_APP + '&PageTypeID=4&PageID=747&KeyValue='
  const BEACON_PARCEL = BEACON_MAP + '&KeyValue=';
  const DECATUR_FIPS = '18031';

  class BeaconControl extends Control {
    /**
     * @param {Object} [opt_options] Control options.
     */
    constructor(opt_options) {
      const options = opt_options || {};

      const button = document.createElement('button');
      button.title = "Open parcel in Beacon";

      // Beacon logo, served from mapstatic like the other button icons. Source is
      // beacon.schneidercorp.com/Images/DefaultTheme/logo-small.png — it must be
      // copied to static/assets/beacon.png rather than hotlinked, because that
      // host serves cross-origin-resource-policy: same-origin and would block the
      // request. No rebuild needed to swap it; it's an external URL, not bundled.
      // Until the file exists we fall back to a generic parcel glyph.
      const icon = document.createElement('img');
      icon.setAttribute('height', '100%');
      icon.alt = 'Beacon';
      icon.addEventListener('error', function () {
        button.innerHTML = '<svg height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
          '<path d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3z"/><path d="M9 3v15M15 6v15"/></svg>';
      }, false);
      icon.src = 'https://mapstatic.millhousen.com/assets/beacon.png';
      button.appendChild(icon);

      const element = document.createElement('div');
      element.className = 'beacon-button ol-unselectable ol-control';
      element.appendChild(button);

      super({
        element: element,
        target: options.target,
      });

      button.addEventListener('click', this.handleBeacon.bind(this), false);
    }

    handleBeacon() {
      // Open synchronously so the popup stays inside the user gesture, then
      // redirect once the parcel lookup resolves. Awaiting first gets blocked.
      const win = window.open('', '_blank');
      const center = map.getView().getCenter();

      const geometry = JSON.stringify({
        x: center[0],
        y: center[1],
        spatialReference: {wkid: 4326}
      });
      const url = serviceUrl + layer + '/query?f=json' +
        '&geometry=' + encodeURIComponent(geometry) +
        '&geometryType=esriGeometryPoint&inSR=4326' +
        '&spatialRel=esriSpatialRelIntersects' +
        '&outFields=parcel_id,county_fips&returnGeometry=false';

      fetch(url)
        .then(function (response) { return response.json(); })
        .then(function (data) {
          const feature = (data.features || [])[0];
          const attrs = feature ? feature.attributes : null;
          if (attrs && attrs.parcel_id && attrs.county_fips === DECATUR_FIPS) {
            return BEACON_PARCEL + encodeURIComponent(attrs.parcel_id);
          }
          return BEACON_MAP;
        })
        .catch(function () { return BEACON_MAP; })
        .then(function (target) {
          if (win) {
            win.location = target;
            win.focus();
          } else {
            // Popup blocked — fall back to navigating this tab.
            window.location = target;
          }
        });
    }
  }

// Search control
const search = new SearchNominatim();
// Move to the position on selection in the control list
search.on('select', function (e) {
    // console.log(e);
    map.getView().animate({
        center: toLonLat(e.coordinate),
        zoom: Math.max(map.getView().getZoom(), 17)
    });
});

var map = new Map({
    // defaultControls() supplies Zoom (+/-), Rotate and Attribution; embed mode
    // keeps those and drops everything else.
    controls: defaultControls().extend(EMBED ? [] : [new MapillaryControl()]),
    target: 'map',
    layers: [
        new LayerGroup({
            'title': 'Base maps',
            layers: [
            new TileLayer({
                    title: 'USGS 1998',
                    type: 'base',
                    visible: false,
                    extent: [-88.0952557, 37.7705156, -84.6881968, 41.7579125],
                    source: new TileWMS({
                      url: 'https://di-ingov.img.arcgis.com/arcgis/services/DynamicWebMercator/NRCS_1998/ImageServer/WMSServer',
                      attributions: '<a href="https://imagery.gio.in.gov/" target="_blank">IndianaMap</a>',
                      params: {
                        'LAYERS': 'NRCS_1998',
                        'TILED': true,
                        'VERSION': "1.3.0"
                        }
                    })
            }),
            new TileLayer({
                title: 'IndianaMap 2005',
                type: 'base',
                visible: false,
                extent: [-88.0952557, 37.7705156, -84.6881968, 41.7579125],
                source: new TileWMS({
                  url: 'https://di-ingov.img.arcgis.com/arcgis/services/DynamicWebMercator/Indiana_2005_Imagery/ImageServer/WMSServer',
                  attributions: '<a href="https://imagery.gio.in.gov/" target="_blank">IndianaMap</a>',
                  params: {
                    'LAYERS': 'Indiana_2005_Imagery',
                    'TILED': true,
                    'VERSION': "1.3.0"
                    }
                })
        }),
                new TileLayer({
                    title: 'IndianaMap 2012',
                    type: 'base',
                    visible: false,
                    extent: [-88.0952557, 37.7705156, -84.6881968, 41.7579125],
                    source: new TileWMS({
                      url: 'https://di-ingov.img.arcgis.com/arcgis/services/DynamicWebMercator/Indiana_2012_Imagery/ImageServer/WMSServer',
                      attributions: '<a href="https://imagery.gio.in.gov/" target="_blank">IndianaMap</a>',
                      params: {
                        'LAYERS': 'Indiana_2012_Imagery',
                        'TILED': true,
                        'VERSION': "1.3.0"
                        }
                    })
            }),
                new TileLayer({
                        title: 'IndianaMap 2017',
                        type: 'base',
                        visible: false,
                        extent: [-88.1296687, 37.7558263, -84.6483203, 41.7885827],
                        source: new TileWMS({
                          url: 'https://di-ingov.img.arcgis.com/arcgis/services/DynamicWebMercator/Indiana_2016_2019_Imagery/ImageServer/WMSServer',
                          attributions: '<a href="https://imagery.gio.in.gov/" target="_blank">IndianaMap</a>',
                          params: {
                            'LAYERS': 'Indiana_2016_2019_Imagery',
                            'TILED': true,
                            'VERSION': "1.3.0"
                            }
                        })
                }),
                new TileLayer({
                  // Indiana_Current_Imagery is "latest available per county"; over
                  // Millhousen it currently serves the 2022 flight (scene
                  // in2022_03921442_06). Retitle if Decatur is reflown.
                  title: 'IndianaMap 2022',
                  type: 'base',
                  visible: false,
                  extent: [-88.1296687, 37.7558265, -84.6985666, 41.8130539],
                  source: new TileWMS({
                    url: 'https://di-ingov.img.arcgis.com/arcgis/services/DynamicWebMercator/Indiana_Current_Imagery/ImageServer/WMSServer',
                    attributions: '<a href="https://imagery.gio.in.gov/" target="_blank">IndianaMap</a>',
                    params: {
                      'LAYERS': 'Indiana_Current_Imagery',
                      'TILED': true,
                      'VERSION': "1.3.0"
                      }
                  })
          }),
                new TileLayer({
                    title: "ESRI Imagery",
                    type: 'base',
                    visible: false,
                    source: new XYZ ({
                        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                        attributions: '<a href="https://maps.google.com" target="_blank">Google</a>',
                        maxZoom: 19
                    })
                }),
                // Bing Imagery — disabled 2026-08-02.
                // Microsoft retired Bing Maps for Enterprise Basic (free) accounts on
                // 2025-06-30, so this key now returns 403 DeniedCredentials from the
                // Imagery/Metadata call OL makes before requesting any tile. Free keys
                // are no longer issued; the replacement path is a paid Bing Enterprise
                // licence (itself ending 2028-06-30) or Azure Maps, which would need a
                // subscription key embedded client-side. ESRI and Google Imagery already
                // cover this ground, so the layer is simply retired.
                // new TileLayer({
                //     title: 'Bing Imagery',
                //     type: 'base',
                //     source: new BingMaps({
                //         key: 'Aubq-fee16cj4ggBXEDsaqkDVIr9A0wJFr0B0zCNPszADliqFzWWguD1Tfb0lJSb',
                //         imagerySet: 'Aerial',
                //         maxZoom: 19
                //     })
                // }),
                new TileLayer({
                    title: "Google Imagery",
                    type: 'base',
                    visible: false,
                    source: new XYZ ({
                        url: 'http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}',
                        attributions: '<a href="https://maps.google.com" target="_blank">Google</a>'
                    })
                }),
                new TileLayer({
                    title: "Jennings GIS 2022",
                    type: 'base',
                    visible: false,
                    attributions: 'Jennings County GIS',
                    source: new XYZ ({
                        url: 'https://jenningsin.wthgis.com/tgis/tilesvc.ashx?L=10739&Z={z}&X={x}&Y={y}',
                        maxZoom: 19,
                        minZoom: 7
                    })
                }),
                new TileLayer({
                    title: "Ripley GIS 2020",
                    type: 'base',
                    visible: false,
                    attributions: 'Ripley County GIS',
                    source: new XYZ ({
                        url: 'https://ripleyin.wthgis.com/tgis/tilesvc.ashx?L=9495&Z={z}&X={x}&Y={y}',
                        maxZoom: 19,
                        minZoom: 7
                    })
                }),
                // Decatur County GIS (Beacon) — disabled 2026-08-02.
                // Schneider put Cloudflare bot protection in front of these tiles:
                // requests return 403 with `cf-mitigated: challenge` plus
                // `cross-origin-resource-policy: same-origin`, so they can never load
                // as cross-origin <img> tiles no matter what the visitor does.
                // Pending: public-records request to Decatur County for the source
                // orthos (GeoTIFF), which we'd tile ourselves and serve from mapstatic.
                // beaconGrid / beaconGrid2 and the ESRI:102673 proj4 def are left in
                // place above so re-enabling is a plain uncomment.
                // new TileLayer({
                //     title: "Decatur GIS 2024",
                //     type: 'base',
                //     attributions: 'Decatur County GIS',
                //     source: new XYZ ({
                //         url: 'https://beacon.schneidercorp.com/Services/ArcGISTile/29477/tile/{z}/{y}/{x}',
                //         projection: 'ESRI:102673',
                //         tileGrid: beaconGrid
                //     })
                // }),
                // new TileLayer({
                //     title: "Decatur GIS 2022",
                //     type: 'base',
                //     attributions: 'Decatur County GIS',
                //     source: new XYZ ({
                //         url: 'https://beacon.schneidercorp.com/Services/ArcGISTile/24678/tile/{z}/{y}/{x}',
                //         projection: 'ESRI:102673',
                //         tileGrid: beaconGrid
                //     })
                // }),
                // new TileLayer({
                //     title: "Decatur GIS 2020",
                //     type: 'base',
                //     attributions: 'Decatur County GIS',
                //     source: new XYZ ({
                //         url: 'https://beacon.schneidercorp.com/Services/ArcGISTile/19076/tile/{z}/{y}/{x}',
                //         projection: 'ESRI:102673',
                //         tileGrid: beaconGrid
                //     })
                // }),
                // new TileLayer({
                //     title: "Decatur GIS 2018",
                //     type: 'base',
                //     attributions: 'Decatur County GIS',
                //     source: new XYZ ({
                //         url: 'https://beacon.schneidercorp.com/Services/ArcGISTile/11717/tile/{z}/{y}/{x}',
                //         projection: 'ESRI:102673',
                //         tileGrid: beaconGrid2
                //     })
                // }),
                // new TileLayer({
                //     title: "Decatur GIS 2016",
                //     type: 'base',
                //     attributions: 'Decatur County GIS',
                //     source: new XYZ ({
                //         url: 'https://beacon.schneidercorp.com/Services/ArcGISTile/4307/tile/{z}/{y}/{x}',
                //         projection: 'ESRI:102673',
                //         tileGrid: beaconGrid2
                //     })
                // }),
                new TileLayer({
                    // CalTopo mosaics the most recent scanned USGS quad per area, so
                    // the vintage varies with location; the Millhousen 7.5' quad that
                    // covers the town is the 1958 edition. Adjacent quads may differ.
                    title: "USGS Topo 1958",
                    type: 'base',
                    visible: false,
                    source: new XYZ ({
                        url: 'https://caltopo.s3.amazonaws.com/topo/{z}/{x}/{y}.png',
                        attributions: 'USGS, caltopo.com',
                        // Coverage stops at z16; z17+ return 403 from S3. Capping here
                        // makes OL over-zoom the z16 tiles instead of going blank.
                        maxZoom: 16
                    })
                }),
                new TileLayer({
                        title: 'USGS Modern Topo',
                        type: 'base',
                        visible: false,
                        extent: [-88.1296687, 37.7558263, -84.6483203, 41.7885827],
                        source: new TileWMS({
                          url: 'https://basemap.nationalmap.gov/arcgis/services/USGSTopo/MapServer/WMSServer',
                          attributions: '<a href="https://www.usgs.gov/programs/national-geospatial-program/national-map" target="_blank">USGS</a>',
                          params: {
                            'LAYERS': 0,
                            'TILED': true,
                            'VERSION': "1.3.0"
                            }
                        })
                }),
                new TileLayer({
                    title: "Google Maps",
                    type: 'base',
                    visible: false,
                    source: new XYZ ({
                        url: 'https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}',
                        attributions: '<a href="https://maps.google.com" target="_blank">Google</a>'
                    })
                }),
                new TileLayer({
                    title: 'OSM',
                    type: 'base',
                    visible: true,
                    source: new SourceOSM()
                }),
            ]
        }),
        // Decatur County topo / LiDAR relief, rendered at 4 m/px (native ~z15),
        // so the pyramid stops at 15 and OL upscales past that.
        new TileLayer({
            title: "Decatur Co Topo",
            visible: false,
            extent: [-85.741909, 39.109641, -85.239546, 39.474486],
            source: new XYZ({
              attributions: 'Map: Kenny Stier · LiDAR: IndianaMap · USGS NHD · FEMA NFHL · © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
              url: 'https://mapstatic.millhousen.com/layers/DecaturTopo/tiles/{z}/{x}/{y}.png',
              minZoom: 10,
              maxZoom: 15
            })
        }),
        // LiDAR hillshade from the statewide DEM. ImageServer renders it on demand
        // via a rasterFunction, so there's nothing to host. Semi-transparent so it
        // can be draped over imagery to read terrain, old road traces and ravines.
        new TileLayer({
            title: "LiDAR Hillshade",
            visible: false,
            opacity: 0.6,
            source: new TileArcGISRest({
              url: 'https://di-ingov.img.arcgis.com/arcgis/rest/services/DynamicWebMercator/Indiana_2016_2020_DEM/ImageServer',
              attributions: '<a href="https://imagery.gio.in.gov/" target="_blank">IndianaMap</a> LiDAR',
              params: {
                'renderingRule': '{"rasterFunction":"Hillshade"}',
                'format': 'png32'
              }
            })
          }),
        // SSURGO soil map units - the same polygons Web Soil Survey draws, taken
        // straight from the NRCS Soil Data Mart WMS (Decatur County is survey
        // area IN031). The service renders the MUSYM codes into the image, so
        // an ImageWMS single request per view is used rather than tiles, which
        // would clip and repeat the labels at every tile seam. It only speaks
        // WMS 1.1.1, and it draws nothing coarser than ~90 m/px, hence minZoom.
        new ImageLayer({
            title: "Soil Survey",
            visible: false,
            minZoom: 10,
            opacity: 0.9,
            source: new ImageWMS({
              url: 'https://sdmdataaccess.nrcs.usda.gov/Spatial/SDM.wms',
              attributions: '<a href="https://websoilsurvey.nrcs.usda.gov/" target="_blank">USDA-NRCS Web Soil Survey</a> (SSURGO)',
              ratio: 1,
              params: {
                'LAYERS': 'mapunitpoly',
                'VERSION': '1.1.1',
                'TRANSPARENT': true
              }
            })
          }),
        new TileLayer({
            title: "Drone Footage",
            visible: false,
            source: new XYZ ({
                url: 'https://mapstatic.millhousen.com/layers/drone/tiles/{z}/{x}/{y}.png',
                attributions: 'Kenny Stier'
            })
        }),
        // Tiled from HA1955_3.png (7161x7112, 0.365 m/px) with gdal2tiles --xyz.
        // Native resolution sits between z18 and z19, so the pyramid stops at 19.
        new TileLayer({
            title: "HA 1955",
            visible: false,
            extent: [-85.444597, 39.202010, -85.421099, 39.220092],
            source: new XYZ({
              attributions: '© <a href="https://www.historicaerials.com/viewer">Historic Aerials</a>',
              url: 'https://mapstatic.millhousen.com/layers/HA1955/tiles/{z}/{x}/{y}.png',
              minZoom: 12,
              maxZoom: 19
            })
          }),
        // Tiled from IGS1940_2.png (5573x4550, 1.262 m/px) — native resolution
        // matches z17, so the pyramid stops there.
        new TileLayer({
            title: "IGS 1940",
            visible: false,
            extent: [-85.460452, 39.196527, -85.397275, 39.236490],
            source: new XYZ({
              attributions: '© <a href="https://igws.indiana.edu/IHAPI/">Indiana Geological Survey</a>',
              url: 'https://mapstatic.millhousen.com/layers/IGS1940/tiles/{z}/{x}/{y}.png',
              minZoom: 12,
              maxZoom: 17
            })
          }),
          // Tiled from PlatMap1882_4.png (1681x1296, 1.114 m/px) — z18 so the
          // hand-lettered names stay legible rather than being downsampled to z17.
          new TileLayer({
            title: "Plat Map 1882",
            visible: false,
            extent: [-85.440698, 39.204892, -85.423872, 39.214944],
            source: new XYZ({
              attributions: 'Decatur County 1882 Atlas',
              url: 'https://mapstatic.millhousen.com/layers/PlatMap1882/tiles/{z}/{x}/{y}.png',
              minZoom: 12,
              maxZoom: 18
            })
          }),
          new VectorLayer({
            title: 'Street Names',
            declutter: true,
            visible: false,
            source: new VectorSource({
              format: new GeoJSON(),
              url: 'https://mapstatic.millhousen.com/layers/streets.geojson',
            }),
            style: function (feature) {
              style.getText().setText(feature.get('old_name'));
              return style;
            },
          }),
          new VectorLayer({
            title: 'Parcels',
            visible: false,
            minZoom: 13,
            source: new VectorSource({
                format: new EsriJSON(),
                url: function (extent, resolution, projection) {
                  // ArcGIS Server only wants the numeric portion of the projection ID.
                  const srid = projection
                    .getCode()
                    .split(/:(?=\d+$)/)
                    .pop();
              
                  const url =
                    serviceUrl +
                    layer +
                    '/query/?f=json&' +
                    'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
                    encodeURIComponent(
                      '{"xmin":' +
                        extent[0] +
                        ',"ymin":' +
                        extent[1] +
                        ',"xmax":' +
                        extent[2] +
                        ',"ymax":' +
                        extent[3] +
                        ',"spatialReference":{"wkid":' +
                        srid +
                        '}}'
                    ) +
                    '&geometryType=esriGeometryEnvelope&inSR=' +
                    srid +
                    '&outFields=*' +
                    '&outSR=' +
                    srid;
              
                  return url;
                },
                strategy: tileStrategy(
                    createXYZ({
                      tileSize: 512,
                    })
                  ),
                attributions:
                  '<a href="https://www.in.gov/gis/">Indiana Geographic Information Office</a>)',
              }),
            style: function (feature) {
              style.getText().setText(feature.get('old_name'));
              return parcelStyle;
            },
          }),
    ],
    view: new View({
    center: [-85.43384, 39.21061],
    zoom: 17,
    constrainResolution: true
    })
});

const style = new Style({
    text: new Text({
      font: 'bold 11px "Open Sans", "Arial Unicode MS", "sans-serif"',
      placement: 'line',
      fill: new Fill({
        color: 'white',
      }),
    }),
  });

// ---- Measurement: distance & area ---------------------------------------
// useGeographic() means geometry coordinates are lon/lat, so ol/sphere must be
// told EPSG:4326 explicitly — its EPSG:3857 default returns 0 on this map.
// Results are shown in US customary units (ft/mi, sq ft/acres) to match how
// land is talked about locally.
const MEASURE_PROJECTION = {projection: 'EPSG:4326'};

function formatLength(meters) {
  const feet = meters * 3.280839895;
  if (feet < 5280) {
    return Math.round(feet).toLocaleString() + ' ft';
  }
  return (feet / 5280).toFixed(2) + ' mi';
}

// Under 0.2 ac: sq ft only. 0.2 ac up to 20,000 sq ft: both. Above that: acres only.
function formatArea(sqMeters) {
  const acres = sqMeters / 4046.8564224;
  const sqFt = sqMeters * 10.763910417;
  const sqFtText = Math.round(sqFt).toLocaleString() + ' sq ft';
  const acresText = acres.toFixed(2) + ' ac';
  if (acres <= 0.2) {
    return sqFtText;
  }
  if (sqFt <= 20000) {
    return acresText + ' (' + sqFtText + ')';
  }
  return acresText;
}

function measureOf(geometry) {
  if (geometry instanceof Polygon) {
    return formatArea(sphereGetArea(geometry, MEASURE_PROJECTION));
  }
  return formatLength(sphereGetLength(geometry, MEASURE_PROJECTION));
}

// Where the running tooltip sits: inside an area, or at the end of a line.
function measureTipCoord(geometry) {
  if (geometry instanceof Polygon) {
    return geometry.getInteriorPoint().getCoordinates().slice(0, 2);
  }
  return geometry.getLastCoordinate();
}

const measureSource = new VectorSource();
const measureLabel = new Text({
  font: 'bold 13px "Open Sans", "Arial Unicode MS", "sans-serif"',
  fill: new Fill({color: '#fff'}),
  stroke: new Stroke({color: 'rgba(0, 0, 0, 0.75)', width: 3}),
  overflow: true
});
const measureFeatureStyle = new Style({
  fill: new Fill({color: 'rgba(255, 170, 40, 0.25)'}),
  stroke: new Stroke({color: '#ff8c00', width: 3}),
  text: measureLabel
});
const measureLayer = new VectorLayer({
  source: measureSource,
  displayInLayerSwitcher: false,
  style: function (feature) {
    measureLabel.setText(feature.get('measure') || '');
    return measureFeatureStyle;
  }
});
map.addLayer(measureLayer);

const measureTipElement = document.createElement('div');
measureTipElement.className = 'measure-tooltip';
const measureTip = new Overlay({
  element: measureTipElement,
  offset: [14, 0],
  positioning: 'center-left',
  stopEvent: false
});

function clearMeasurements() {
  measureSource.clear();
}

// Only one measure mode runs at a time.
let activeMeasure = null;

class MeasureControl extends Control {
  /**
   * @param {Object} [opt_options] Control options. `type` is 'LineString' or 'Polygon'.
   */
  constructor(opt_options) {
    const options = opt_options || {};
    const type = options.type === 'Polygon' ? 'Polygon' : 'LineString';

    const button = document.createElement('button');
    button.title = (type === 'Polygon' ? 'Measure area' : 'Measure distance') +
      ' — double-click to clear, Esc to cancel';
    button.innerHTML = type === 'Polygon'
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M4 7l8-4 8 5-3 10-9 3-4-6z"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 19L19 5"/><circle cx="5" cy="19" r="2.4"/><circle cx="19" cy="5" r="2.4"/></svg>';

    const element = document.createElement('div');
    element.className = (type === 'Polygon' ? 'measure-area-button' : 'measure-distance-button') +
      ' ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target
    });

    this.type_ = type;
    this.button_ = button;
    this.draw_ = null;
    this.changeKey_ = null;

    button.addEventListener('click', this.toggle.bind(this), false);
    button.addEventListener('dblclick', function (event) {
      event.preventDefault();
      clearMeasurements();
    }, false);
  }

  toggle() {
    if (this.draw_) {
      this.deactivate();
      return;
    }
    if (activeMeasure) {
      activeMeasure.deactivate();
    }
    this.activate();
  }

  activate() {
    const self = this;
    this.draw_ = new Draw({
      source: measureSource,
      type: this.type_
    });

    this.draw_.on('drawstart', function (event) {
      const geometry = event.feature.getGeometry();
      measureTipElement.textContent = measureOf(geometry);
      measureTip.setPosition(measureTipCoord(geometry));
      map.addOverlay(measureTip);
      self.changeKey_ = geometry.on('change', function () {
        measureTipElement.textContent = measureOf(geometry);
        measureTip.setPosition(measureTipCoord(geometry));
      });
    });

    this.draw_.on('drawend', function (event) {
      event.feature.set('measure', measureOf(event.feature.getGeometry()));
      self.stopTip_();
    });

    map.addInteraction(this.draw_);
    this.button_.classList.add('measure-active');
    activeMeasure = this;
  }

  stopTip_() {
    if (this.changeKey_) {
      unByKey(this.changeKey_);
      this.changeKey_ = null;
    }
    map.removeOverlay(measureTip);
  }

  deactivate() {
    if (this.draw_) {
      map.removeInteraction(this.draw_);
      this.draw_ = null;
    }
    this.stopTip_();
    this.button_.classList.remove('measure-active');
    if (activeMeasure === this) {
      activeMeasure = null;
    }
  }
}

// Esc abandons an in-progress sketch and leaves measure mode.
document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape' && activeMeasure) {
    activeMeasure.deactivate();
  }
}, false);

// ---- ?layers= : restrict which layers are offered -------------------------
// Values are slugified titles, comma separated, e.g. ?layers=osm,ha1955,parcels
// Untitled layers (the measure layer) are always kept. If nothing matches we
// leave the map alone rather than rendering an empty one, and log the valid
// names so they're discoverable from the console.
(function applyLayersParam() {
  const raw = urlParams.get('layers');
  if (!raw) {
    return;
  }
  const wanted = new Set(raw.split(',').map(layerSlug).filter(Boolean));

  const titled = [];
  (function scan(collection) {
    collection.getArray().forEach(function (l) {
      if (l instanceof LayerGroup) {
        scan(l.getLayers());
      } else if (l.get('title')) {
        titled.push(l);
      }
    });
  })(map.getLayers());

  const matched = titled.filter(function (l) { return wanted.has(layerSlug(l.get('title'))); });
  if (!matched.length) {
    console.warn('[map] ?layers= matched nothing; showing all. Valid names:',
      titled.map(function (l) { return layerSlug(l.get('title')); }).join(','));
    return;
  }

  (function prune(collection) {
    const keep = collection.getArray().filter(function (l) {
      if (l instanceof LayerGroup) {
        prune(l.getLayers());
        return l.getLayers().getLength() > 0;
      }
      return !l.get('title') || wanted.has(layerSlug(l.get('title')));
    });
    collection.clear();
    keep.forEach(function (l) { collection.push(l); });
  })(map.getLayers());

  // If the default base map was filtered out, promote the first surviving one
  // so the map isn't left with no background at all.
  const bases = matched.filter(function (l) { return l.get('type') === 'base'; });
  if (bases.length && !bases.some(function (l) { return l.getVisible(); })) {
    bases.forEach(function (l, i) { l.setVisible(i === 0); });
  }
})();

// ---- ?on= : which layers start switched on --------------------------------
// Same slugs as ?layers=. Overlays are visible iff listed; if a base map is
// listed it becomes the active one. Unlike Link's positional l= bitfield this
// is name-based, so it survives layers being added or reordered.
(function applyOnParam() {
  const raw = urlParams.get('on');
  if (!raw) {
    return;
  }
  const on = new Set(raw.split(',').map(layerSlug).filter(Boolean));

  const titled = [];
  (function scan(collection) {
    collection.getArray().forEach(function (l) {
      if (l instanceof LayerGroup) {
        scan(l.getLayers());
      } else if (l.get('title')) {
        titled.push(l);
      }
    });
  })(map.getLayers());

  const bases = titled.filter(function (l) { return l.get('type') === 'base'; });
  const overlays = titled.filter(function (l) { return l.get('type') !== 'base'; });

  overlays.forEach(function (l) { l.setVisible(on.has(layerSlug(l.get('title')))); });

  const chosen = bases.filter(function (l) { return on.has(layerSlug(l.get('title'))); })[0];
  if (chosen) {
    bases.forEach(function (l) { l.setVisible(l === chosen); });
  }
})();

// ---- Soil identify -------------------------------------------------------
// While the Soil Survey layer is on, a click asks the NRCS WMS what map unit
// sits under that point and shows it in a panel in the bottom-left corner.
// The WMS only answers text/plain (no JSON), and only in 1.1.1, so the request
// is built by hand rather than via ImageWMS#getFeatureInfoUrl: a small square
// window around the click, queried at its centre pixel. mapunitpolyextended is
// queried rather than the drawn mapunitpoly because it carries the attributes —
// the drawn layer returns only the MUSYM code.
const SOIL_WMS_URL = 'https://sdmdataaccess.nrcs.usda.gov/Spatial/SDM.wms';
const SOIL_INFO_LAYER = 'mapunitpolyextended';

// [attribute, label, optional formatter]. Blank values are dropped, so map units
// that don't carry a field simply show fewer rows.
const SOIL_FIELDS = [
  ['musym', 'Map unit'],
  ['slopegradwta', 'Slope', function (v) { return v + '%'; }],
  ['drclassdcd', 'Drainage'],
  ['hydgrpdcd', 'Hydrologic group'],
  ['niccdcd', 'Capability class', function (v) { return v + ' (nonirrigated)'; }],
  ['aws0100wta', 'Water storage', function (v) { return v + ' cm to 100 cm deep'; }],
  ['flodfreqdcd', 'Flooding'],
  ['areasymbol', 'Survey area']
];

const soilLayer = map.getLayers().getArray().filter(function (l) {
  return !(l instanceof LayerGroup) && l.get('title') === 'Soil Survey';
})[0];

function escapeHtml(text) {
  return String(text).replace(/[&<>"]/g, function (c) {
    return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c];
  });
}

// MapServer's text/plain reply is a flat list of `  key = 'value'` lines under a
// `Feature <id>:` header. Only the first feature is asked for, so the last
// assignment for a key wins and a plain object is enough.
function parseFeatureInfo(text) {
  const attributes = {};
  const pattern = /^\s*([A-Za-z_][\w]*)\s*=\s*'([\s\S]*?)'\s*$/gm;
  let match;
  while ((match = pattern.exec(text)) !== null) {
    attributes[match[1]] = match[2];
  }
  return attributes;
}

function soilInfoUrl(lonLat) {
  const centre = transform(lonLat, 'EPSG:4326', 'EPSG:3857');
  const half = 60;
  return SOIL_WMS_URL + '?' + new URLSearchParams({
    SERVICE: 'WMS',
    VERSION: '1.1.1',
    REQUEST: 'GetFeatureInfo',
    LAYERS: SOIL_INFO_LAYER,
    QUERY_LAYERS: SOIL_INFO_LAYER,
    STYLES: '',
    SRS: 'EPSG:3857',
    BBOX: [centre[0] - half, centre[1] - half, centre[0] + half, centre[1] + half].join(','),
    WIDTH: '101',
    HEIGHT: '101',
    X: '50',
    Y: '50',
    FORMAT: 'image/png',
    INFO_FORMAT: 'text/plain',
    FEATURE_COUNT: '1'
  }).toString();
}

function soilInfoHtml(attributes) {
  const rows = SOIL_FIELDS.map(function (field) {
    const value = attributes[field[0]];
    if (!value) {
      return '';
    }
    const shown = field[2] ? field[2](value) : value;
    return '<tr><th>' + escapeHtml(field[1]) + '</th><td>' + escapeHtml(shown) + '</td></tr>';
  }).join('');

  return '<h4>' + escapeHtml(attributes.muname || attributes.musym || 'Soil map unit') + '</h4>' +
    '<table>' + rows + '</table>';
}

class SoilInfoControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const element = document.createElement('div');
    element.className = 'soil-info ol-unselectable ol-control';
    element.innerHTML =
      '<button class="soil-info-close" type="button" title="Close">&times;</button>' +
      '<div class="soil-info-body"></div>';

    super({
      element: element,
      target: options.target
    });

    this.body_ = element.querySelector('.soil-info-body');
    this.requestId_ = 0;

    element.querySelector('.soil-info-close').addEventListener('click', this.hide.bind(this), false);
  }

  hide() {
    this.element.classList.remove('soil-info-open');
  }

  // Idle prompt: shown when the layer is switched on but nothing is picked yet.
  prompt() {
    this.body_.innerHTML = '<p class="soil-info-hint">Click the map to identify a soil.</p>';
    this.element.classList.add('soil-info-open');
  }

  // Later clicks can resolve before earlier ones, so stale replies are dropped.
  identify(lonLat) {
    const self = this;
    const id = ++this.requestId_;

    this.body_.innerHTML = '<p class="soil-info-hint">Looking up soil&hellip;</p>';
    this.element.classList.add('soil-info-open');

    fetch(soilInfoUrl(lonLat))
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }
        return response.text();
      })
      .then(function (text) {
        if (id !== self.requestId_) {
          return;
        }
        const attributes = parseFeatureInfo(text);
        self.body_.innerHTML = attributes.mukey
          ? soilInfoHtml(attributes)
          : '<p class="soil-info-hint">No soil map unit here.</p>';
      })
      .catch(function (error) {
        if (id !== self.requestId_) {
          return;
        }
        console.warn('[map] soil lookup failed', error);
        self.body_.innerHTML = '<p class="soil-info-hint">Soil lookup failed. Try again.</p>';
      });
  }
}

// Wired up only if the layer survived ?layers=; a click while a measure sketch
// is running belongs to the sketch, not to the identify.
if (soilLayer) {
  const soilInfo = new SoilInfoControl();
  map.addControl(soilInfo);

  soilLayer.on('change:visible', function () {
    if (soilLayer.getVisible()) {
      soilInfo.prompt();
    } else {
      soilInfo.hide();
    }
  });
  if (soilLayer.getVisible()) {
    soilInfo.prompt();
  }

  map.on('singleclick', function (event) {
    if (!soilLayer.getVisible() || activeMeasure) {
      return;
    }
    soilInfo.identify(event.coordinate);
  });
}

// ---- Decatur Co Topo legend -----------------------------------------------
// The topo's symbology isn't readable from the tiles alone, so a legend and
// full source credits open with the layer, like the soil panel does. The
// images live next to the tiles on mapstatic; the 2x copy is for HiDPI.
const TOPO_STATIC = 'https://mapstatic.millhousen.com/layers/DecaturTopo/';

const topoLayer = map.getLayers().getArray().filter(function (l) {
  return !(l instanceof LayerGroup) && l.get('title') === 'Decatur Co Topo';
})[0];

class TopoLegendControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const element = document.createElement('div');
    element.className = 'topo-legend ol-unselectable ol-control';
    element.innerHTML =
      '<button class="topo-legend-close" type="button" title="Close">&times;</button>' +
      '<h4>Decatur Co Topo</h4>' +
      '<a href="' + TOPO_STATIC + 'legend@2x.png" target="_blank" title="Open full-size legend">' +
        '<img src="' + TOPO_STATIC + 'legend.png" srcset="' + TOPO_STATIC + 'legend.png 1x, ' +
        TOPO_STATIC + 'legend@2x.png 2x" alt="Decatur County topo map legend">' +
      '</a>' +
      '<p class="topo-legend-credits">Map: Kenny Stier · LiDAR: <a href="https://www.indianamap.org/" target="_blank">IndianaMap</a>' +
        ' · Streams: <a href="https://www.usgs.gov/national-hydrography" target="_blank">USGS NHD</a>' +
        ' · Flood zones: <a href="https://www.fema.gov/flood-maps/national-flood-hazard-layer" target="_blank">FEMA NFHL</a>' +
        ' · Facilities: <a href="https://www.indianamap.org/" target="_blank">IndianaMap</a>' +
        ' · Roads &amp; places: © <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors</p>' +
      '<p class="topo-legend-note">Not for navigation. Flood zones for planning only; pipeline routes approximate.</p>';

    super({
      element: element,
      target: options.target
    });

    element.querySelector('.topo-legend-close').addEventListener('click', this.hide.bind(this), false);
  }

  show() {
    this.element.classList.add('topo-legend-open');
  }

  hide() {
    this.element.classList.remove('topo-legend-open');
  }
}

// Closing the panel only hides it; toggling the layer off and on brings it back.
if (topoLayer) {
  const topoLegend = new TopoLegendControl();
  map.addControl(topoLegend);

  topoLayer.on('change:visible', function () {
    if (topoLayer.getVisible()) {
      topoLegend.show();
    } else {
      topoLegend.hide();
    }
  });
  if (topoLayer.getVisible()) {
    topoLegend.show();
  }
}

// ---- Point info: coordinates & elevation ----------------------------------
// While active, a click drops a pin and shows the lon/lat and ground elevation
// there. Elevation comes from Indiana's 2016-2020 LiDAR bare-earth DEM (the one
// behind the hillshade layer), whose pixel values are already feet NAVD88. That
// service answers NoData outside the state, so USGS 3DEP via EPQS is the fallback.
// The tool takes the activeMeasure slot so it is mutually exclusive with the
// measure tools, Esc leaves it, and the soil identify stays out of its way.
const DEM_IDENTIFY_URL = 'https://di-ingov.img.arcgis.com/arcgis/rest/services/' +
  'DynamicWebMercator/Indiana_2016_2020_DEM/ImageServer/identify';
const EPQS_URL = 'https://epqs.nationalmap.gov/v1/json';

function indianaElevation(lonLat) {
  const url = DEM_IDENTIFY_URL + '?' + new URLSearchParams({
    f: 'json',
    geometryType: 'esriGeometryPoint',
    geometry: JSON.stringify({x: lonLat[0], y: lonLat[1], spatialReference: {wkid: 4326}}),
    returnGeometry: 'false',
    returnCatalogItems: 'false'
  }).toString();
  return fetch(url)
    .then(function (response) { return response.json(); })
    .then(function (data) {
      const feet = parseFloat(data.value);
      return isNaN(feet) ? null : {feet: feet, source: 'Indiana LiDAR DEM'};
    });
}

function usgsElevation(lonLat) {
  const url = EPQS_URL + '?' + new URLSearchParams({
    x: lonLat[0],
    y: lonLat[1],
    wkid: '4326',
    units: 'Feet'
  }).toString();
  return fetch(url)
    .then(function (response) { return response.json(); })
    .then(function (data) {
      const feet = parseFloat(data.value);
      // EPQS reports -1000000 where it has no coverage.
      return isNaN(feet) || feet < -10000 ? null : {feet: feet, source: 'USGS 3DEP'};
    });
}

function lookupElevation(lonLat) {
  return indianaElevation(lonLat)
    .catch(function () { return null; })
    .then(function (result) { return result || usgsElevation(lonLat); });
}

function formatLatLon(lonLat) {
  return lonLat[1].toFixed(6) + ', ' + lonLat[0].toFixed(6);
}

const pointInfoElement = document.createElement('div');
pointInfoElement.className = 'point-info';
pointInfoElement.innerHTML =
  '<div class="point-info-bubble">' +
    '<button class="point-info-close" type="button" title="Close">&times;</button>' +
    '<div class="point-info-coords"></div>' +
    '<div class="point-info-elev"></div>' +
  '</div>' +
  '<div class="point-info-pin"></div>';
const pointInfoOverlay = new Overlay({
  element: pointInfoElement,
  positioning: 'bottom-center',
  stopEvent: true
});
const pointInfoCoords = pointInfoElement.querySelector('.point-info-coords');
const pointInfoElev = pointInfoElement.querySelector('.point-info-elev');

pointInfoElement.querySelector('.point-info-close').addEventListener('click', function () {
  pointInfoOverlay.setPosition(undefined);
}, false);

// Clicking the coordinates copies them as "lat, lon", the order Google Maps and
// most GPS apps accept when pasted.
pointInfoCoords.title = 'Click to copy';
pointInfoCoords.addEventListener('click', function () {
  const text = pointInfoCoords.textContent;
  if (navigator.clipboard && text) {
    navigator.clipboard.writeText(text).then(function () {
      pointInfoCoords.classList.add('point-info-copied');
      setTimeout(function () { pointInfoCoords.classList.remove('point-info-copied'); }, 1000);
    });
  }
}, false);

class PointInfoControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.title = 'Coordinates & elevation — click the map, Esc to stop';
    button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="6"/><path d="M12 2v5M12 17v5M2 12h5M17 12h5"/></svg>';

    const element = document.createElement('div');
    element.className = 'point-info-button ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target
    });

    this.button_ = button;
    this.clickKey_ = null;
    this.requestId_ = 0;

    button.addEventListener('click', this.toggle.bind(this), false);
  }

  toggle() {
    if (this.clickKey_) {
      this.deactivate();
      return;
    }
    if (activeMeasure) {
      activeMeasure.deactivate();
    }
    this.activate();
  }

  activate() {
    this.clickKey_ = map.on('singleclick', this.identify.bind(this));
    map.addOverlay(pointInfoOverlay);
    map.getTargetElement().classList.add('point-info-cursor');
    this.button_.classList.add('measure-active');
    activeMeasure = this;
  }

  deactivate() {
    if (this.clickKey_) {
      unByKey(this.clickKey_);
      this.clickKey_ = null;
    }
    pointInfoOverlay.setPosition(undefined);
    map.removeOverlay(pointInfoOverlay);
    map.getTargetElement().classList.remove('point-info-cursor');
    this.button_.classList.remove('measure-active');
    if (activeMeasure === this) {
      activeMeasure = null;
    }
  }

  // Later clicks can resolve before earlier ones, so stale replies are dropped.
  identify(event) {
    const lonLat = event.coordinate;
    const id = ++this.requestId_;

    pointInfoCoords.textContent = formatLatLon(lonLat);
    pointInfoElev.textContent = 'Elevation: looking up…';
    pointInfoOverlay.setPosition(lonLat);

    lookupElevation(lonLat)
      .then(function (result) {
        if (id !== this.requestId_) {
          return;
        }
        pointInfoElev.textContent = result
          ? 'Elevation: ' + Math.round(result.feet).toLocaleString() + ' ft (' +
            Math.round(result.feet * 0.3048).toLocaleString() + ' m) · ' + result.source
          : 'Elevation: no data here';
      }.bind(this))
      .catch(function (error) {
        if (id !== this.requestId_) {
          return;
        }
        console.warn('[map] elevation lookup failed', error);
        pointInfoElev.textContent = 'Elevation: lookup failed';
      }.bind(this));
  }
}

// ---- Swipe comparison ----------------------------------------------------
// Clips every non-base overlay to the right of a draggable divider, so whichever
// overlay is switched on can be compared against the base map underneath it.
// Grabbed from the map rather than listed by hand so new overlays are picked up
// automatically; the measure layer has no title and is excluded.
const swipeOverlays = map.getLayers().getArray().filter(function (l) {
  return !(l instanceof LayerGroup) && l.get('title');
});
const swipe = new Swipe({
  rightLayers: swipeOverlays,
  position: 0.5,
  orientation: 'vertical'
});
let swipeActive = false;

class SwipeToggleControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.title = 'Swipe to compare overlays against the base map';
    button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 3v18"/><path d="M8 8L4 12l4 4"/><path d="M16 8l4 4-4 4"/></svg>';

    const element = document.createElement('div');
    element.className = 'swipe-button ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target
    });

    this.button_ = button;
    button.addEventListener('click', this.toggle.bind(this), false);
  }

  toggle() {
    swipeActive = !swipeActive;
    if (swipeActive) {
      map.addControl(swipe);
      this.button_.classList.add('swipe-active');
    } else {
      map.removeControl(swipe);
      this.button_.classList.remove('swipe-active');
    }
  }
}

// Link tracks view state in the URL and is useful either way, so it stays.
// It applies its own positional l= visibility bitfield after our params run, so
// when ?on= is in play we drop l= from the tracked set and let the named param win.
map.addInteraction(new Link(
  urlParams.get('on') ? {params: ['x', 'y', 'z', 'r']} : undefined
));

// ?embed=1 leaves only the zoom +/- and attribution from defaultControls().
if (!EMBED) {
  var layerSwitcher = new LayerSwitcher();
  var gmapsbutton = new GMapsControl();
  var osmbutton = new OSMControl();
  var homebutton = new homeControl();
  var beaconbutton = new BeaconControl();
  var measuredistancebutton = new MeasureControl({type: 'LineString'});
  var measureareabutton = new MeasureControl({type: 'Polygon'});
  map.addControl(layerSwitcher);
  map.addControl(homebutton);
  map.addControl(osmbutton);
  map.addControl(gmapsbutton);
  map.addControl(beaconbutton);
  map.addControl(measuredistancebutton);
  map.addControl(measureareabutton);
  map.addControl(new SwipeToggleControl());
  map.addControl(new PointInfoControl());
  map.addControl(search);
}
